export default {
	title: 'Ses rendez-vous médicaux',
	carnetsante: 'Munissez-vous du carnet de santé de votre enfant lors de ces rendez-vous.',
	doute: 'Cependant en cas de doute sur l’état de santé de votre enfant, n’hésitez pas à consulter votre médecin.',
	aucunexamen: {
		title: 'Aucun examen nécessaire.',
		text: 'En cas de doute sur l’état de santé de votre enfant, n’hésitez pas à consulter votre médecin.'
	},
	mois1: {
		examens: [
			{
				title: 'L\'examen des 8 premiers jours',
				text: 'Votre médecin a dû effectuer un examen approfondi de votre bébé et établir un certificat de santé obligatoire à cet âge.'
			},
			{
				title: 'L\'examen des 14 premiers jours',
				text: 'Un examen clinique est prévu durant lequel les fréquences cardiaque et respiratoire de votre enfant, sa mobilité, etc… sont examinées.'
			},
			{
				title: 'L\'examen du 1<sup>er</sup> mois',
				text: 'Votre médecin notera la taille, le poids, le périmètre crânien, le développement psychomoteur et fera un examen clinique de votre bébé.'
			}
		],
		liensutiles: [
			'depistageenfant'
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 2 mois',
			examens: [
				{
					title: 'Examen médical des 2 mois.'
				}
			]
		}
	},
	mois2: {
		examens: [
			{
				title: 'L\'examen des 2 mois',
				text: 'Votre médecin examinera les yeux de votre bébé, évaluera sa réactivité à la voix et au bruit et le développement général de votre bébé, notamment ses mouvements.'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 3 mois',
			examens: [
				{
					title: 'Examen médical des 3 mois.'
				}
			]
		}
	},
	mois3: {
		examens: [
			{
				title: 'L\'examen des 3 mois',
				text: 'Votre médecin notera la taille, le poids, le périmètre crânien, le développement psychomoteur, et fera un examen clinique de votre bébé.'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 4 mois',
			examens: [
				{
					title: 'Examen médical des 4 mois.'
				}
			]
		}
	},
	mois4: {
		examens: [
			{
				title: 'Examen médical des 4 mois',
				text: 'Votre médecin examinera les yeux de votre bébé, évaluera sa réactivité à la voix et au bruit, évaluera le développement général de votre bébé, notamment ses mouvements.'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 5 et 6 mois',
			examens: [
				{
					title: 'Examen médical des 5 mois.'
				},
				{
					title: 'Examen médical des 6 mois.'
				}
			]
		}
	},
	mois6: {
		examens: [
			{
				title: 'L\'examen des 5 mois',
				text: 'Votre médecin notera la taille, le poids, le périmètre crânien, le développement psychomoteur et fera un examen clinique de votre bébé.'
			},
			{
				title: 'L\'examen des 6 mois',
				text: 'Votre médecin refera le même examen que lors du 5<sup>ème</sup> mois.'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 7 et 8 mois',
			examens: [
				{
					title: 'Examen médical des 8 mois (obligatoire) <p class="mb-0"><i>Obtention du certificat de santé</i>.</p>'
				}
			]
		}
	},
	mois8: {
		examens: [
			{
				title: 'L\'examen des 8 mois',
				text: 'L\'examen médical des 8 mois est un examen indispensable. Votre médecin examinera les yeux de votre bébé, évaluera sa réactivité à la voix et au bruit, évaluera le développement général de votre bébé (mouvements …). <i>A l\'issue de l\'examen, votre médecin vous remettra un certificat de santé obligatoire.</i>'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer de 9 à 11 mois',
			examens: [
				{
					title: 'Examen médical des 11 mois.'
				}
			]
		}
	},
	mois11: {
		examens: [
			{
				title: 'L\'examen des 11 mois',
				text: 'Lors de l\'examen médical du 11<sup>ème</sup> mois votre médecin notera la taille, le poids, le périmètre crânien, le développement psychomoteur et fera un examen clinique de votre bébé.'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 12 mois',
			examens: [
				{
					title: 'Examen médical des 12 mois.'
				}
			]
		}
	},
	mois12: {
		examens: [
			{
				title: 'L\'examen des 12 mois',
				text: 'Lors de l\'examen médical du 12<sup>ème</sup> mois votre médecin notera la taille, le poids, le périmètre crânien, le développement psychomoteur et fera un examen clinique de votre bébé.'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: '<b>Le prochain examen aura lieu à 18 mois.</b>',
			examens: [
			]
		}
	},
	mois15: {
		examens: [
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer entre 16 et 18 mois',
			examens: [
				{
					title: 'Examen médical des 18 mois.'
				}
			]
		}
	},
	mois18: {
		examens: [
			{
				title: 'L\'examen des 18 mois',
				text: 'Lors de l\'examen médical du 18<sup>ème</sup> mois, votre médecin notera la taille, le poids, le périmètre crânien, le développement psychomoteur et fera un examen clinique de votre bébé.'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: '<b>Le prochain examen aura lieu à 24 mois.</b>',
			examens: [
			]
		}
	},
	mois23: {
		examens: [
			{
				title: 'L\'examen des 24 mois',
				text: 'L\'examen du 24<sup>ème</sup> mois est un examen indispensable. Votre médecin examinera la vue et l\'audition de votre enfant. Il évaluera aussi son développement. <i>A l\'issue de l\'examen, votre médecin vous remettra un certificat de santé obligatoire.</i>'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 2 ans',
			examens: [
				{
					title: 'Examen médical des 2 ans (obligatoire) <p class="mb-0"><i>Obtention du certificat de santé</i>.</p>'
				}
			]
		}
	},
	mois24: {
		examens: [
			{
				title: 'L\'examen des 2 ans',
				text: ' Lors de l\'examen médical des 2 ans, votre médecin notera la taille, le poids, le périmètre crânien, le développement psychomoteur, et fera un examen clinique de votre enfant.'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 3 ans',
			examens: [
				{
					title: 'Examen des 3 ans.'
				},
				{
					title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i></p>'
				}
			]
		}
	},
	mois36: {
		examens: [
			{
				title: 'L\'examen des 3 ans',
				text: 'Au cours de l\'examen au cours des 3 ans, votre médecin examinera la vue (mesure de près et de loin), l\'ouïe et le développement de votre enfant (taille, poids…).'
			},
			{
				title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)',
				text: '<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i><p>Les dents de votre enfant sont fragiles. Pour les préserver et éviter les caries, il est important de <b>consulter le chirurgien-dentiste au moins une fois par an</b>, même s\'il n\'y a pas de douleur.</p><p><b>C\'est pourquoi, votre enfant est invité chaque année à un rendez-vous <i>&laquo; M\'T dents tous les ans ! &raquo;</i> dès l\'âge de 3 ans et jusqu\'à ses 24 ans</b>.<p>Lors de ce rendez-vous, le chirurgien-dentiste examine les dents, les gencives de votre enfant et vous dispense des messages de prévention adaptés à son âge.</p><p><b>Prenez rendez-vous</b> chez votre chirurgien-dentiste habituel ou chez un chirurgien-dentiste près de chez vous. Pensez à préciser que vous venez pour un rendez-vous <b><i>&laquo; M\'T dents tous les ans ! &raquo;</i></b>.</p><p>Documents à présenter lors de ce rendez-vous : <b>pour ne pas payer le rendez-vous et les soins</b>, il suffit de présenter au chirurgien-dentiste : <ul><li>la carte Vitale mise à jour d\'un des deux parents;</li><li>et la carte ou attestation de complémentaire santé où est rattaché votre enfant.</li></ul></p><p>Si vous n\'avez pas de complémentaire santé, ce rendez-vous et les soins seront pris en charge intégralement par l\'Assurance maladie.</p><p>N\'oubliez pas le carnet de santé de votre enfant pour que le chirurgien-dentiste le complète.</p><p>Un courrier d\'information vous sera envoyé par voie postale. Vous pouvez retrouver sur votre espace Ameli toutes les informations concernant les rendez-vous &laquo; M\'T dents tous les ans ! &raquo;</p></p>'
			}
		],
		liensutiles: [
			'mtdent'
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 4 ans',
			examens: [
				{
					title: 'Examen médical des 4 ans.'
				},
				{
					title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i></p>'
				}
			]
		}
	},
	mois48: {
		examens: [
			{
				title: 'L\'examen des 4 ans',
				text: 'Votre médecin examinera la vue (mesure de près et de loin) et l\'audition de votre enfant. Il mesurera et pèsera votre enfant afin de calculer son indice de masse corporelle (IMC). Il le rapportera sur la courbe de corpulence présente dans le carnet de santé de votre enfant afin de s\'assurer de la bonne croissance de votre enfant.'
			},
			{
				title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)',
				text: '<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i><p>Les dents de votre enfant sont fragiles. Pour les préserver et éviter les caries, il est important de <b>consulter le chirurgien-dentiste au moins une fois par an</b>, même s\'il n\'y a pas de douleur.</p><p><b>C\'est pourquoi, votre enfant est invité chaque année à un rendez-vous <i>&laquo; M\'T dents tous les ans ! &raquo;</i> dès l\'âge de 3 ans et jusqu\'à ses 24 ans</b>.<p>Lors de ce rendez-vous, le chirurgien-dentiste examine les dents, les gencives de votre enfant et vous dispense des messages de prévention adaptés à son âge.</p><p><b>Prenez rendez-vous</b> chez votre chirurgien-dentiste habituel ou chez un chirurgien-dentiste près de chez vous. Pensez à préciser que vous venez pour un rendez-vous <b><i>&laquo; M\'T dents tous les ans ! &raquo;</i></b>.</p><p>Documents à présenter lors de ce rendez-vous : <b>pour ne pas payer le rendez-vous et les soins</b>, il suffit de présenter au chirurgien-dentiste : <ul><li>la carte Vitale mise à jour d\'un des deux parents;</li><li>et la carte ou attestation de complémentaire santé où est rattaché votre enfant.</li></ul></p><p>Si vous n\'avez pas de complémentaire santé, ce rendez-vous et les soins seront pris en charge intégralement par l\'Assurance maladie.</p><p>N\'oubliez pas le carnet de santé de votre enfant pour que le chirurgien-dentiste le complète.</p><p>Un document d\'information vous sera envoyé par mail. Vous pouvez retrouver sur votre espace Ameli toutes les informations concernant les rendez-vous &laquo; M\'T dents tous les ans ! &raquo;</p></p>'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 5 ans',
			examens: [
				{
					title: 'Examen médical des 5 ans.'
				},
				{
					title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i></p>'
				}
			]
		}
	},
	mois60: {
		examens: [
			{
				title: 'L\'examen des 5 ans',
				text: 'Votre médecin examinera la vue (mesure de près et de loin) et l\'audition de votre enfant. Il mesurera et pèsera votre enfant afin de calculer son indice de masse corporelle (IMC). Il le rapportera sur la courbe de corpulence présente dans le carnet de santé de votre enfant afin de s\'assurer de la bonne croissance de votre enfant.'
			},
			{
				title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)',
				text: '<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i><p>Les dents de votre enfant sont fragiles. Pour les préserver et éviter les caries, il est important de <b>consulter le chirurgien-dentiste au moins une fois par an</b>, même s\'il n\'y a pas de douleur.</p><p><b>C\'est pourquoi, votre enfant est invité chaque année à un rendez-vous <i>&laquo; M\'T dents tous les ans ! &raquo;</i> dès l\'âge de 3 ans et jusqu\'à ses 24 ans</b>.<p>Lors de ce rendez-vous, le chirurgien-dentiste examine les dents, les gencives de votre enfant et vous dispense des messages de prévention adaptés à son âge.</p><p><b>Prenez rendez-vous</b> chez votre chirurgien-dentiste habituel ou chez un chirurgien-dentiste près de chez vous. Pensez à préciser que vous venez pour un rendez-vous <b><i>&laquo; M\'T dents tous les ans ! &raquo;</i></b>.</p><p>Documents à présenter lors de ce rendez-vous : <b>pour ne pas payer le rendez-vous et les soins</b>, il suffit de présenter au chirurgien-dentiste : <ul><li>la carte Vitale mise à jour d\'un des deux parents;</li><li>et la carte ou attestation de complémentaire santé où est rattaché votre enfant.</li></ul></p><p>Si vous n\'avez pas de complémentaire santé, ce rendez-vous et les soins seront pris en charge intégralement par l\'Assurance maladie.</p><p>N\'oubliez pas le carnet de santé de votre enfant pour que le chirurgien-dentiste le complète.</p><p>Un document d\'information vous sera envoyé par mail. Vous pouvez retrouver sur votre espace Ameli toutes les informations concernant les rendez-vous &laquo; M\'T dents tous les ans ! &raquo;</p></p>'
			}
		],
		liensutiles: [
		],
		prochainexamens: {
			titre: 'A ne pas manquer à 6 ans',
			examens: [
				{
					title: 'Examen médical des 6 ans (obligatoire).'
				},
				{
					title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i></p>'
				}
			]
		}
	},
	mois84: {
		examens: [
			{
				title: 'L\'examen des 6 ans',
				text: 'Le médecin réalisera un test de vision (vision de près, vision de loin), un test auditif, un test de développement psychomoteur (votre enfant peut-il attraper une balle qui rebondit, décrire une image …) et un test de langage. Le plus souvent, cet examen est réalisé par le médecin scolaire. Si ce n\'est pas le cas, parlez-en à votre médecin traitant lors d\'une prochaine visite.'
			},
			{
				title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)',
				text: '<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i><p>Les dents de votre enfant sont fragiles. Pour les préserver et éviter les caries, il est important de <b>consulter le chirurgien-dentiste au moins une fois par an</b>, même s\'il n\'y a pas de douleur.</p><p><b>C\'est pourquoi, votre enfant est invité chaque année à un rendez-vous <i>&laquo; M\'T dents tous les ans ! &raquo;</i> dès l\'âge de 3 ans et jusqu\'à ses 24 ans</b>.<p>Lors de ce rendez-vous, le chirurgien-dentiste examine les dents, les gencives de votre enfant et vous dispense des messages de prévention adaptés à son âge.</p><p><b>Prenez rendez-vous</b> chez votre chirurgien-dentiste habituel ou chez un chirurgien-dentiste près de chez vous. Pensez à préciser que vous venez pour un rendez-vous <b><i>&laquo; M\'T dents tous les ans ! &raquo;</i></b>.</p><p>Documents à présenter lors de ce rendez-vous : <b>pour ne pas payer le rendez-vous et les soins</b>, il suffit de présenter au chirurgien-dentiste : <ul><li>la carte Vitale mise à jour d\'un des deux parents;</li><li>et la carte ou attestation de complémentaire santé où est rattaché votre enfant.</li></ul></p><p>Si vous n\'avez pas de complémentaire santé, ce rendez-vous et les soins seront pris en charge intégralement par l\'Assurance maladie.</p><p>N\'oubliez pas le carnet de santé de votre enfant pour que le chirurgien-dentiste le complète.</p><p>Un document d\'information vous sera envoyé par voie postale (6 ans) ou par mail (7 ans). Vous pouvez retrouver sur votre espace Ameli toutes les informations concernant les rendez-vous &laquo; M\'T dents tous les ans ! &raquo;</p></p>'
			}
		],
		liensutiles: [
			'mtdent'
		],
		prochainexamens: {
			titre: 'A ne pas manquer entre 8 et 9 ans',
			examens: [
				{
					title: 'Examen médical des 8 ans.'
				},
				{
					title: 'Examen médical des 9 ans.'
				},
				{
					title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i></p>'
				}
			]
		}
	},
	mois108: {
		examens: [
			{
				title: 'L\'examen des 8 ans',
				text: 'Votre médecin réalisera un test de vision (vision de près, vision de loin), un test auditif, un test de développement psychomoteur (votre enfant connaît il les jours de la semaine, s\'habille-t-il tout seul …) et un test de langage. Cet examen sera complété par un examen somatique (examens, de la peau, du dos, du cœur et des premiers signes de puberté s\'ils existent).'
			},
			{
				title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)',
				text: '<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i><p>Les dents de votre enfant sont fragiles. Pour les préserver et éviter les caries, il est important de <b>consulter le chirurgien-dentiste au moins une fois par an</b>, même s\'il n\'y a pas de douleur.</p><p><b>C\'est pourquoi, votre enfant est invité chaque année à un rendez-vous <i>&laquo; M\'T dents tous les ans ! &raquo;</i> dès l\'âge de 3 ans et jusqu\'à ses 24 ans</b>.<p>Lors de ce rendez-vous, le chirurgien-dentiste examine les dents, les gencives de votre enfant et vous dispense des messages de prévention adaptés à son âge.</p><p><b>Prenez rendez-vous</b> chez votre chirurgien-dentiste habituel ou chez un chirurgien-dentiste près de chez vous. Pensez à préciser que vous venez pour un rendez-vous <b><i>&laquo; M\'T dents tous les ans ! &raquo;</i></b>.</p><p>Documents à présenter lors de ce rendez-vous : <b>pour ne pas payer le rendez-vous et les soins</b>, il suffit de présenter au chirurgien-dentiste : <ul><li>la carte Vitale mise à jour d\'un des deux parents;</li><li>et la carte ou attestation de complémentaire santé où est rattaché votre enfant.</li></ul></p><p>Si vous n\'avez pas de complémentaire santé, ce rendez-vous et les soins seront pris en charge intégralement par l\'Assurance maladie.</p><p>N\'oubliez pas le carnet de santé de votre enfant pour que le chirurgien-dentiste le complète.</p><p>Un document d\'information vous sera envoyé par mail. Vous pouvez retrouver sur votre espace Ameli toutes les informations concernant les rendez-vous &laquo; M\'T dents tous les ans ! &raquo;</p></p>'
			}
		],
		liensutiles: [
			'mtdent'
		],
		prochainexamens: {
			titre: 'A ne pas manquer entre 10 et 13 ans',
			examens: [
				{
					title: 'Examen médical (entre 11 et 13 ans).'
				},
				{
					title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i></p>'
				}
			]
		}
	},
	mois156: {
		examens: [
			{
				title: 'L\'examen médical (entre 11 et 13 ans)',
				text: 'Cet examen permettra à votre enfant de faire le point sur son développement et sera un moment privilégié pour échanger sur les aspects de sa santé et les évolutions qu\'il subit.</p><p> Le médecin réalisera au cours de cet examen, un test de vision (vision de près, vision de loin), un test auditif, un test de langage, un examen somatique (examens de la peau, du dos, du cœur, des premiers signes de puberté s\'ils existent,…) et appréciera son développement psycho affectif (votre enfant établit-il des projets, comment parle-t-il de son passé, présente-t-il des troubles du sommeil …).'
			},
			{
				title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)',
				text: '<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i><p>Les dents de votre enfant sont fragiles. Pour les préserver et éviter les caries, il est important de <b>consulter le chirurgien-dentiste au moins une fois par an</b>, même s\'il n\'y a pas de douleur.</p><p><b>C\'est pourquoi, votre enfant est invité chaque année à un rendez-vous <i>&laquo; M\'T dents tous les ans ! &raquo;</i> dès l\'âge de 3 ans et jusqu\'à ses 24 ans</b>.<p>Lors de ce rendez-vous, le chirurgien-dentiste examine les dents, les gencives de votre enfant et vous dispense des messages de prévention adaptés à son âge.</p><p><b>Prenez rendez-vous</b> chez votre chirurgien-dentiste habituel ou chez un chirurgien-dentiste près de chez vous. Pensez à préciser que vous venez pour un rendez-vous <b><i>&laquo; M\'T dents tous les ans ! &raquo;</i></b>.</p><p>Documents à présenter lors de ce rendez-vous : <b>pour ne pas payer le rendez-vous et les soins</b>, il suffit de présenter au chirurgien-dentiste : <ul><li>la carte Vitale mise à jour d\'un des deux parents;</li><li>et la carte ou attestation de complémentaire santé où est rattaché votre enfant.</li></ul></p><p>Si vous n\'avez pas de complémentaire santé, ce rendez-vous et les soins seront pris en charge intégralement par l\'Assurance maladie.</p><p>N\'oubliez pas le carnet de santé de votre enfant pour que le chirurgien-dentiste le complète.</p><p>Un document d\'information vous sera envoyé par mail (10,11 et 13 ans) ou par voie postale (12 ans). Vous pouvez retrouver sur votre espace Ameli toutes les informations concernant les rendez-vous &laquo; M\'T dents tous les ans ! &raquo;</p></p>'
			}
		],
		liensutiles: [
			'mtdent'
		],
		prochainexamens: {
			titre: 'A ne pas manquer entre 13 et 18 ans',
			examens: [
				{
					title: 'Examen médical (entre 15 et 16 ans).'
				},
				{
					title: 'Examen bucco-dentaire M\'T dents tous les ans ! (Offert)<p class="mb-0"><i>Intégralement pris en charge par l\'Assurance Maladie et sans avance des frais.</i></p>'
				}
			]
		}
	}
};
